import { useMemo } from 'react';

import {
  buildSolutionItems,
  type SolutionListItem,
} from './solutions-dropdown.utils';

/**
 * The dropdown's rows, rebuilt only when the context's `solutions` list is a
 * different array. Pass the raw `ctx.solutions` from its own selector: a
 * selector that maps/sorts inside returns a new array on every emission of the
 * app machine, and `useCtxSelector` reads that as a change (PSTUDIO-4554).
 */
export function useSolutionItems(
  solutions: Parameters<typeof buildSolutionItems>[0]
): SolutionListItem[] {
  return useMemo(() => buildSolutionItems(solutions), [solutions]);
}
